import * as React from 'react';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

export interface IAgeCalculatorProps {
    setAgeFilter: (age: number) => void;
}

function AgeCalculator({ setAgeFilter }: IAgeCalculatorProps, ref) {

    const compareYear = '2025';

    const [input, setInput] = useState({
        year: '',
        month: '',
        day: ''
    });
    const [age, setAge] = useState(0);
    const [valid, setValid] = useState({
        month: true,
        day: true,
        year: true
    })

    useImperativeHandle(
        ref,
        () => ({
            reset() {
                setInput({
                    year: '',
                    month: '',
                    day: ''
                });
                setAge(0);
                setValid({
                    month: true,
                    day: true,
                    year: true
                })
            }
        }),
    )

    const handleInputChange = (e) => {
        let val = e.currentTarget.value;
        if (['month', 'day'].includes(e.currentTarget.name)) {
            val = val.slice(0, 2);
        }
        if (['year'].includes(e.currentTarget.name)) {
            val = val.slice(0, 4);
        }

        setInput({
            ...input,
            [e.currentTarget.name]: val
        })
    }


    const validate = (input) => {
        const y = parseInt(input.year);
        const m = parseInt(input.month);
        const d = parseInt(input.day);

        let newValid = {
            year: y > 1900 && y < (new Date().getFullYear()) + 2,
            month: m > 0 && m < 13,
            day: d > 0 && d < 32,
        }

        return newValid;
    }

    const calculate = (e) => {
        e.preventDefault();
        const validation = validate(input);
        setValid(validation);

        if (
            !validation.year
            || !validation.month
            || !validation.day
        ) {
            setAge(0)
            return false;
        }

        // @ts-ignore
        const birthday = new Date(`${input.month}/${input.day}/${input.year}`);
        const compareDate = new Date(`09/01/${compareYear}`);
        const compareAge = Math.floor((compareDate.getTime() - birthday.getTime()) / (1000 * 3600 * 24 * 365));
        setAge(compareAge);
        setAgeFilter(compareAge);
    }

    const errored = !valid.year || !valid.month || !valid.day;
    return <div className="age-calculator">
        <p>Age Calculator</p>
        <Form onSubmit={calculate}>
            <div className="inline-form">
                <Form.Control className={valid.month ? '' : 'errored'} placeholder="MM" type="number" name="month" value={input.month} onChange={handleInputChange}></Form.Control>
                <Form.Control className={valid.day ? '' : 'errored'} placeholder="DD" type="number" name="day" value={input.day} onChange={handleInputChange}></Form.Control>
                <Form.Control className={valid.year ? '' : 'errored'} placeholder="YYYY" type="number" name="year" value={input.year} onChange={handleInputChange}></Form.Control>
            </div>
            <Button size="sm" type="submit">Find Age</Button>
            {errored && <div className="error-message">Please enter a valid date</div>}
            <div>{age} years old</div>
        </Form>
    </div>
}

export default forwardRef(AgeCalculator);